/**
 * UI Element used to show the signin message for the user
 * @returns 
 */
export const OidcSigninCallback = () => {
    return <>Signing you in...</>;
}
